import { SVGProps } from 'react';
import { ReactComponent } from 'icons/logout.svg';

/**
 * @deprecated Move to storybook instead
 */
export const LogoutIcon = (props: SVGProps<SVGSVGElement>) => {
  return <ReactComponent className="merc-icon-logout" {...props} />;
};
